module.exports = __webpack_public_path__ + "img/yunizaiyiqi.69003496.png";